import { Component, OnInit } from '@angular/core';
import { Card } from 'src/app/_model/card';
import { CardService } from 'src/app/_service/card.service';
import {DatalayerService} from "../../../_service/datalayer.service";

@Component({
    selector: 'app-cards',
    templateUrl: './cards.component.html',
    styleUrls: ['./cards.component.scss']
})
export class CardsComponent implements OnInit {

    cards: Card[];

    constructor(
      private cardService: CardService,
      private datalayerService: DatalayerService,
    ) { }

    ngOnInit(): void {
        this.getCards();
    }

    getCards() {
        this.cardService.get('home').subscribe(
            res => this.getCardsSuccess(res),
            err => this.getCardsError(err)
        )
    }

    sendCardMenuDatalayer(title: string) {
        this.datalayerService.sendDatalayer('menu_veiculos_comerciais', {
            escolha_usuario: title,
        })
    }

    getCardsError(err: any) {
        console.log(err);
    }

    getCardsSuccess(res: Card[]) {
        this.cards = res;
    }
}
